/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Gpindicativeorder_Modal_Required3Inputs */

const en_coinvestments_gpindicativeorder_modal_required3 = /** @type {(inputs: Coinvestments_Gpindicativeorder_Modal_Required3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indicative order is required`)
};

/**
* | output |
* | --- |
* | "Indicative order is required" |
*
* @param {Coinvestments_Gpindicativeorder_Modal_Required3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_gpindicativeorder_modal_required3 = /** @type {((inputs?: Coinvestments_Gpindicativeorder_Modal_Required3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Gpindicativeorder_Modal_Required3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_gpindicativeorder_modal_required3(inputs)
});
export { coinvestments_gpindicativeorder_modal_required3 as "coInvestments_gpIndicativeOrder_modal_required" }